import React from 'react';

// Membership upsell component. Opens the membership page in new widow and resets the form to display previous state.
// Upon return to the CDP the customer can resume saving the location.
export default function MembershipOffer(props) {
    return (
        <>
            <div className="membership-offer">
                <h2>Own part of your Co-op today</h2>
                <p>At Co-op, your membership means more. It means you own part of your local Co-op.</p>
                <button 
                    className="become-member" 
                    type="button" 
                    onClick={() =>  {window.open(props.url, "_blank"); props.setOffer(false)}} 
                    aria-label="Become a member"
                >Become a Member</button>
            </div>
            <div className="no-thanks buttons">
                <button 
                    type="button" 
                    className="cancel btn secondary" 
                    onClick={()=>props.saveNewRetail()} 
                    aria-label="No thanks"
                >No thanks</button>
            </div>

        </>
    );
}
